/**
 * ui/thumbnail-ui.js
 * Gắn IntersectionObserver vào các thẻ Customizer để chỉ yêu cầu thumbnail cho thẻ đang nằm trong vùng nhìn.
 * Sub-tab/panel đang ẩn (display:none hoặc drawer đóng) thì thẻ không giao với viewport,
 * nên thumbnail chỉ được tạo lần đầu khi người dùng mở đúng sub-tab đó.
 */

import { thumbnailService } from './thumbnail-service.js';

const CARD_SELECTOR =
  '.char-card[data-preset], #group-outfit .visual-card[data-val], #group-hair .visual-card[data-val]';

/** Xác định loại thumbnail và giá trị từ một thẻ; trả về null nếu không phải thẻ hỗ trợ. */
export function describeCard(card) {
  if (card.dataset.preset) return { kind: 'preset', value: card.dataset.preset };
  if (!card.dataset.val) return null;
  if (card.closest('#group-hair')) return { kind: 'hair', value: card.dataset.val };
  if (card.closest('#group-outfit')) return { kind: 'outfit', value: card.dataset.val };
  return null;
}

let observer = null;

/**
 * Khởi tạo quan sát các thẻ có thumbnail. Gọi một lần sau khi DOM sẵn sàng.
 * @returns {IntersectionObserver|null}
 */
export function initCardThumbnails(service = thumbnailService, root = document) {
  if (observer || typeof IntersectionObserver === 'undefined') return observer;

  observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const card = entry.target;
        obs.unobserve(card);
        const img = card.querySelector('.card-thumb');
        const info = describeCard(card);
        if (img && info) service.request(info.kind, info.value, img, card);
      });
    },
    { rootMargin: '60px' }
  );

  root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
    if (card.dataset.preset && !card.title) {
      const name = card.querySelector('.char-name')?.textContent?.trim() || '';
      const role = card.querySelector('.char-role')?.textContent?.trim() || '';
      if (name && role) card.title = `${name} – ${role}`;
      else if (name) card.title = name;
    }
    observer.observe(card);
  });
  return observer;
}
